import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Subject } from 'rxjs';
import { EndCustomerStateService } from '../services/end-customer.state.service';

export type FormAction = 'save' | 'cancel';

@Injectable({
    providedIn: 'root',
})
export class CustomerDetailsService {
    readonly #isEditing = new BehaviorSubject<boolean>(false);
    isEditing$ = this.#isEditing.asObservable();

    readonly #canSave = new BehaviorSubject<boolean>(false);
    canSave$ = this.#canSave.asObservable();

    readonly #formAction = new Subject<FormAction>();
    formAction$ = this.#formAction.asObservable();

    readonly #endCustomerStateService = inject(EndCustomerStateService);

    readonly selectedEndCustomer$ = toObservable(
        this.#endCustomerStateService.selectedEndCustomer,
    );

    updateEditing(isEditing: boolean) {
        this.#isEditing.next(isEditing);
    }

    updateCanSave(canSave: boolean) {
        this.#canSave.next(canSave);
    }

    performFormAction(action: FormAction) {
        this.#formAction.next(action);
    }
}
